import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function RedefinirSenha() {
  const [token, setToken] = useState("");
  const [senha, setSenha] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const search =
      location.search && location.search.length > 0
        ? location.search.slice(1)
        : (window.location.hash.split("?")[1] || "");
    const params = new URLSearchParams(search);
    const t = params.get("token") || "";
    setToken(t);
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr("");

    if (!token) { setErr("Token ausente."); return; }
    if (senha.length < 6) { setErr("A senha deve ter pelo menos 6 caracteres."); return; }
    if (senha !== confirm) { setErr("As senhas não conferem."); return; }

    setLoading(true);
    try {
      const res = await fetch("https://welaunchyou.com.br/crm-wly/redefinir_senha.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, nova_senha: senha }),
      });
      const raw = await res.text();
      let data = null;
      try { data = raw ? JSON.parse(raw) : null; } catch {}
      if (!res.ok) throw new Error((data && data.error) || raw || `HTTP ${res.status}`);
      
      setMsg((data && data.message) || "Senha redefinida com sucesso!");
      setSenha(""); setConfirm("");

      // Aguarda 2 segundos mostrando a mensagem antes de ir para o login
      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (e2) {
      setErr(e2.message || "Erro ao redefinir.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Redefinir Senha</h2>
        {msg && <p className="sucesso">{msg}</p>}
        {err && <p className="erro">{err}</p>}

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Nova senha"
            value={senha}
            onChange={e=>setSenha(e.target.value)}
            required
            autoComplete="new-password"
          />
          <input
            type="password"
            placeholder="Confirmar senha"
            value={confirm}
            onChange={e=>setConfirm(e.target.value)}
            required
            autoComplete="new-password"
          />
          <button
            type="submit"
            disabled={loading || !token}
            title={!token ? "Link sem token válido" : ""}
          >
            {loading ? "Enviando..." : "Redefinir"}
          </button>
        </form>
      </div>
    </div>
  );
}
